var card = $('.card');

if(card.length > 0) {
  //All Card links - detect if external link
  card.click(function (e) {
    var link = $(this).find('.card-link').attr('href');
    var anchor = $(this).find('.card-link');
    if (link) {
      if (e.metaKey) {
        window.open(link);
      } else {
        if (anchor.hasClass('external')) {
  window.open(link);
  } else {
  window.location = link;
  }
  }
  return false;
  }
  });
}

//Read More/less
var descriptionMoreLess = $('.description-more-less');

if(descriptionMoreLess.length > 0) {
  var readMore = $('.read-more');
  readMore.click(function () {
    $(this).parent().parent().toggleClass('rm-trimmed');
  $(this).parent().parent().toggleClass('rm-full');
  });
}

//Tabs General event on click
var tabs = $('.ndbtabs');

if(tabs.length > 0) {
  var tabs_tab = $('.ndbtabs .ndbtab');
   tabs_tab.click(function () {
   tabs_tab.removeClass('active');
   $(this).addClass('active');
   //$('.ndbtabs-contents .ndbtabs-content').fadeOut('fast');
   $('.ndbtabs-contents .ndbtabs-content').removeClass('active');
   var active_tab_content = $(this).attr('tabcontent');
   //$('.' + active_tab_content).fadeIn('fast');
   $('.' + active_tab_content).addClass('active');
  });
}

//function ndbtabsInit() {
  //var ndbtabscontent = $('.ndbtabs-content');
  //ndbtabscontent.css('height','auto');
  //var maxHeight = null;
  //ndbtabscontent.each(function() {
    //maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  //});
  //ndbtabscontent.each(function() {
    //$(this).height(maxHeight);
  //});
//}

//if(tabs.length > 0) {
  //ndbtabsInit();
  //$(window).resize(function () {
    //ndbtabsInit();
  //});
//}

//Accordion
var accordionItems = $('.accordion-items');

if(accordionItems.length > 0) {
  var accordionItemTitle = $('.accordion-item-title');
  accordionItemTitle.click(function () {
    if(!$(this).parent().hasClass('active')){
      $('.accordion-item').removeClass('active');
      $('.accordion-item-content').slideUp();
      $('.accordion-item-form').slideUp();
      $(this).parent().toggleClass('active');
      $(this).parent().find('.accordion-item-content').slideDown();
      $(this).parent().find('.accordion-item-form').slideDown();
    }
    else {
      $(this).parent().removeClass('active');
      $(this).parent().find('.accordion-item-content').slideUp();
      $(this).parent().find('.accordion-item-form').slideUp();
    }
  });
}

//Signup Form
var signupWrapper = $('.signup-check-wrapper');

if(signupWrapper.length > 0) {
  var checkbox = $('.signup-check-wrapper input[type=checkbox]');
  checkbox.on('click',function () {
    if (checkbox.is(':checked')) {
      $(this).parent().parent().toggleClass('active');
    }
    else {
      $(this).parent().parent().removeClass('active');
    }
  });
}

//Disclaimer
var disclaimer = $('.cookie-disclaimer-sidebar');

if(disclaimer.length > 0) {
  var close = $('.global-cookie-disclaimer-close');
  close.on('click',function () {
    disclaimer.fadeOut('fast');
  });
}

function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  let accept = getCookie("accept");
  if (accept != "") {
    disclaimer.toggleClass('inactive');
  } else {
    disclaimer.fadeIn();
  }
}

if(disclaimer.length > 0) {
  var acceptbtn = $('.global-cookie-disclaimer-accept-button');
  acceptbtn.on('click',function () {
    setCookie("accept", true, 30);
    disclaimer.toggleClass('inactive').hide();
  });

}

checkCookie();

//Pagination
var ndbpager = $('.ndb-pager');

if(ndbpager.length > 0) {
  $('.ndb-pager a').each(function(i,a){$(a).attr('href',$(a).attr('href')+'#paginated-list')});
}

//Content parent//Pagination
var ndbcontentparent = $('.ndb-content-parent');

if(ndbcontentparent.length > 0) {
  var richtext = ndbcontentparent.find('.simple-rich-text-block');
  if(richtext.length > 0) {
    richtext.parent().removeClass('medium-18');
    richtext.parent().parent().removeClass('grid-x');
    richtext.parent().parent().removeClass('grid-padding-x');
    richtext.parent().parent().removeClass('grid-container');
    richtext.parent().parent().parent().removeClass('block-ndb-component-half');
  }
}

document.addEventListener( 'wpcf7mailsent', function() {
  $('.wpcf7-list-item').toggleClass('active');
  $(document).find('.wpcf7-response-output').show();
  setTimeout(function () {
    $(document).find('.wpcf7-response-output').hide();
  }, 5000);
}, false );

document.addEventListener( 'wpcf7submit', function() {
  setTimeout(function () {
    $(document).find('.wpcf7-response-output').hide();
    $(document).find('.wpcf7-not-valid-tip').hide();
  }, 5000);
}, false );

$(document).find('.wpcf7-validates-as-email').on('click', function() {
  $('.wpcf7-not-valid-tip').hide();
});

//Hero Banner
var heroBanner = $('.ndb-video-wrapper');

if(heroBanner.length > 0) {
  var DacastDivWrapper = $('.DacastDiv-wrapper');
  var ndberovideoclose = $('.ndb-hero-video-close');
  $('.ndb-video-play').click(function(){
    var heroBannerVideoH = DacastDivWrapper.height();
    var heroBannerVideoW = DacastDivWrapper.width();
    var heroBannerVideoH2 = heroBannerVideoH + 50;
    var heroBannerVideoW2 = null;
    if (window.innerWidth <= 1010) {
      heroBannerVideoW2 = heroBannerVideoW;
    }
    else {
      heroBannerVideoW2 = heroBannerVideoW + 30;
    }
    DacastDivWrapper.css('top','calc(50% - ('+heroBannerVideoH+'px / 2))');
    DacastDivWrapper.css('left','calc(50% - ('+heroBannerVideoW+'px / 2))');
    ndberovideoclose.css('top','calc(50% - ('+heroBannerVideoH2+'px / 2))');
    ndberovideoclose.css('right','calc(50% - ('+heroBannerVideoW2+'px / 2))');
  });
  $(window).resize(function () {
    var heroBannerVideoH = DacastDivWrapper.height();
    var heroBannerVideoW = DacastDivWrapper.width();
    var heroBannerVideoH2 = heroBannerVideoH + 50;
    var heroBannerVideoW2 = null;
    if (window.innerWidth <= 1010) {
      heroBannerVideoW2 = heroBannerVideoW;
    }
    else {
      heroBannerVideoW2 = heroBannerVideoW + 30;
    }
    DacastDivWrapper.css('top','calc(50% - ('+heroBannerVideoH+'px / 2))');
    DacastDivWrapper.css('left','calc(50% - ('+heroBannerVideoW+'px / 2))');
    ndberovideoclose.css('top','calc(50% - ('+heroBannerVideoH2+'px / 2))');
    ndberovideoclose.css('right','calc(50% - ('+heroBannerVideoW2+'px / 2))');
  });
}
